import React from "react";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../localization/labels";
import PageComponent from "../../page/PageComponent";
import IndividualsAdministration from "./IndividualsAdministration";

class IndividualsAdministrationContainer extends PageComponent {
  getComponentTitle = () => {
    return labels.individuals;
  };

  render() {
    return (
      <IndividualsAdministration
        {...this.handlerProps()}
        history={this.props.history}
      />
    );
  }
}

export default withRouter(IndividualsAdministrationContainer);
